var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagType,{tag:"component",staticClass:"cv-list",class:{
    [`${_vm.carbonPrefix}--list--nested`]: _vm.nested,
    [`${_vm.carbonPrefix}--list--ordered`]: _vm.internalOrdered,
    [`${_vm.carbonPrefix}--list--unordered`]: !_vm.internalOrdered,
  },attrs:{"data-nested":_vm.nested}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }